import React from 'react';
import './appointments.css';
import { useSelector } from 'react-redux';

import AppointmentCard from '../components/cards/appointmentCard/appointmentCard';

const PreviousAppointments = ({ activeIndex, returnSelectedAppointment }) => {
    const { previousAppointments } = useSelector(
        (state) => state.appointments
    );

    const handleCardClick = (index, appointment) => {
        returnSelectedAppointment(index, appointment);
    };

    return (
        <div className="mt-5">
            <AppointmentCard
                title="Past Appointments"
                appointments={previousAppointments}
                handleCardClick={handleCardClick}
                activeIndex={activeIndex}
            />
        </div>
    );
};

export default PreviousAppointments;
